export enum PrivateClassBannerEventType {
  PC_BANNER_TRACKING_EVENT = 'pc-banner-tracking-event',
  REFETCH_STATE_EVENT = 'refetch-state-event',
  ON_RESERVE_EVENT = 'on-reserve-event',
  ON_CANCEL_EVENT = 'on-cancel-event',
  ON_CHECK_IN_EVENT = 'on-check-in-event',
  ON_JOIN_CLASS_EVENT = 'on-join-class-event',
  ON_SEE_ALL_EVENT = 'on-see-all-event',
  ON_SELECT_LESSON_EVENT = 'on-select-lesson-event',
  ON_PRESS_LESSONS_EVENT = 'on-press-lessons-event',
  ON_PRESS_FEEDBACK_EVENT = 'on-press-feedback-event',
  ON_RESIZE_EVENT = 'on-resize-event',
  LOCKED_EVENT = 'locked-event',
}

export const PRIVATE_CLASS_EVENT = 'privateClassEvent';

export enum ReservationLockReason {
  CONCURRENT_REQUEST = 'CONCURRENT_REQUEST',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/live-class-events.enum.ts